// extracted by mini-css-extract-plugin
export default {"tabs":"tabs-a4fd","multiple-employee-container":"multiple-employee-container-04cd","padding-for-pulse":"padding-for-pulse-defa"};